import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { translate } from 'react-switch-lang';
import TooltipedIconButton from './Base/TooltipedIconButton';

function RestoreButton({
  onClick, id, text,
}) {
  return (
    <TooltipedIconButton
      text={text}
      onClick={onClick}
      id={id}
      className="btn btn-outline-danger"
      icon="fa fa-child"
    />
  );
}

RestoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default RestoreButton;
